@if (saving) {
  <xui-loading-spinner></xui-loading-spinner>
}
@if (form !== null && !saving) {
  <form class="appointment-edit-form" [formGroup]="form" [class.form-validated]="validate">
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>Title</mat-label>
      <input matInput [formControlName]="'title'" type="text" maxlength="100"/>
    </mat-form-field>
    @if (selectedType?.isPatientAppointment) {
      <div class="w-100">
        @if (hasPatient) {
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Patient</mat-label>
            <input readonly matInput [value]="(patient?.profileId ? patient.profileId.toString().padStart(4, '0') : '') + ' - ' + (patient?.displayName || '')">
          </mat-form-field>
        }
        @if (allowPatientAppointmentsWithoutPatient && hasPatientMetaData && !hasPatient) {
          <div class="w-100 mb-3">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Temporary Patient Details</mat-label>
              <input readonly matInput value=" {{appointmentMetaPatientData.name}} - {{appointmentMetaPatientData.cell ?? appointmentMetaPatientData.email ?? ''}}">
              <button mat-icon-button matSuffix *xuiPermissionRequired="'Clinical.Patients.Write'" (click)="addNewPatient()">
                <mat-icon>library_add</mat-icon>
              </button>
            </mat-form-field>
          </div>
        }
      </div>
    }
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>Start Date & Time</mat-label>
      <xui-mat-datetime [formControlName]="'date'" #datetime="matDatetime" />
      <button mat-icon-button matSuffix (click)="datetime.togglePicker()">
        <mat-icon>today</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>End Date & Time</mat-label>
      <xui-mat-datetime [formControlName]="'endDate'" #endDatetime="matDatetime" />
      <button mat-icon-button matSuffix (click)="endDatetime.togglePicker()">
        <mat-icon>today</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="fill" class="w-100 compact mat-background-reset mb-3" [style.background-color]="selectedType.displayStyle" subscriptSizing="dynamic">
      <mat-label>Appointment Status</mat-label>
      <mat-select [formControlName]="'appointmentType'" required>
        @for (type of appointmentTypes; track type) {
          <mat-option [value]="type.id" [style.background-color]="type.displayStyle">{{type.title}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>Booking Comment</mat-label>
      <textarea matInput [formControlName]="'comment'" maxlength="250"></textarea>
    </mat-form-field>
  </form>
}
